// extracted by mini-css-extract-plugin
module.exports = {"layout":"PageLayout_layout__2WQ3g","mainArea":"PageLayout_mainArea__2ZwM5"};